module.exports = __webpack_public_path__ + "static/scale-model-of-st.-petersburg-florida-02bb335110ddfde8a285ab1c842f22f9.png";